import { render, staticRenderFns } from "./MetaPolicyModal.vue?vue&type=template&id=6888c2c4&scoped=true"
import script from "./MetaPolicyModal.vue?vue&type=script&lang=js"
export * from "./MetaPolicyModal.vue?vue&type=script&lang=js"
import style0 from "./MetaPolicyModal.vue?vue&type=style&index=0&id=6888c2c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6888c2c4",
  null
  
)

export default component.exports